export default __webpack_public_path__ + "static/media/EXR_FactionIcons-04_Augement.5460ccd4.png";